/** Resume-Ziel weicht von der aktiven Konversation ab (und ist gesetzt) →
 * Auto-Switch in die Ursprungs-Konversation nötig, bevor der Run fortgesetzt
 * wird. Leere targetConvoId = kein Switch (defensiv). */
export function needsConvoSwitch(targetConvoId: string, activeConvoId: string | null): boolean {
  if (!targetConvoId) return false;
  return targetConvoId !== activeConvoId;
}
